import { v4 as uuidv4 } from "uuid";
import {
  formatCurrencyOrNumber,
  getQuantityInEaches
} from "./genericFunctions";
import { calculateEaches } from "./storeCreditUtils";

export const freightClaimPoItemMapper = (item: any) => ({
  ...item,
  retail: formatCurrencyOrNumber(item.retail),
  adjustedExtendedRetail: formatCurrencyOrNumber(item.adjustedExtendedRetail),
  quantity: item.ordered,
  received: item.qtyShipped,
  priceUnit: item.unit,
  netPrice: "$0.00",
  transferCost: formatCurrencyOrNumber(item.unitCost),
  pack: item.packOrSize.split("/")[0],
  totalEaches: calculateEaches(item, "FC"),
  uniqueId: uuidv4(),
  inputDisabled: {
    damagedQuantityCases: item.isRandomWeight || item.palletModId
  }
});

export const mapDamagedQuantityWithReceived = (
  poItem: any,
  selectedState: boolean
) => {
  if (poItem.isPalletMod) {
    return;
  }

  if (selectedState) {
    const damagedQuantityEaches = getQuantityInEaches(
      poItem.received,
      poItem.packOrSize,
      poItem.isRandomWeight
    );
    if (poItem.palletModId || poItem.isRandomWeight) {
      poItem.damagedQuantityCases = "0";
      poItem.damagedQuantityEaches = damagedQuantityEaches;
    } else {
      poItem.damagedQuantityCases = poItem.received;
      poItem.damagedQuantityEaches = "0";
    }

    poItem.inputDisabled = {
      damagedQuantityCases: true,
      damagedQuantityEaches: true
    };
  } else {
    poItem.damagedQuantityCases = poItem.initalDamagedQuantityCases || "0";
    poItem.damagedQuantityEaches = poItem.initalDamagedQuantityEaches || "0";
    poItem.inputDisabled = {
      damagedQuantityCases: poItem.isRandomWeight || poItem.palletModId,
      damagedQuantityEaches: false
    };
  }

  poItem.damagedQuantity =
    +poItem.damagedQuantityCases * +poItem.pack +
    +poItem.damagedQuantityEaches +
    "";

  poItem.adjustedExtendedRetail = -(
    +poItem.damagedQuantity *
    +(poItem?.retail?.slice(1)?.replace(/,/g, "") || 0)
  );
};
